import { Clock, MapPin } from "lucide-react";

function fmt(mins) {
  const d = Math.floor(mins / 1440), h = Math.floor((mins % 1440) / 60), m = mins % 60;
  if (d > 0) return `${d} day${d > 1 ? "s" : ""}${h ? ` ${h}h` : ""}`;
  return `${h}h${m ? ` ${String(m).padStart(2, "0")}m` : ""}`;
}

export function LayoverDivider({ segment, next, index }) {
  const mins = segment?.transit_time?.minutes;
  if (mins == null || !next) return null;
  const sameAirport = segment.destination_code === next.origin_code;
  const isLayover = sameAirport && mins < 1440;
  const place = segment.destination_city || segment.destination_name || segment.destination_code;
  const tight = isLayover && mins < 60;
  const long = isLayover && mins > 360;
  const tone = tight
    ? "border-red-200 bg-red-50 text-red-700"
    : long
      ? "border-amber-200 bg-amber-50 text-amber-800"
      : "border-slate-200 bg-slate-50 text-slate-600";
  return (
    <div data-testid={`layover-${index}`} className="flex items-center gap-3 px-2">
      <div className="flex-1 border-t border-dashed border-slate-300" />
      <span className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium ${tone}`}>
        {isLayover ? <Clock className="h-3 w-3" /> : <MapPin className="h-3 w-3" />}
        {isLayover ? "Layover" : "Stay"} · {fmt(mins)} in {place}
        <span className="font-pnr opacity-70">({segment.destination_code})</span>
        {tight ? <span className="font-semibold">· tight connection</span> : null}
      </span>
      <div className="flex-1 border-t border-dashed border-slate-300" />
    </div>
  );
}
